/** Small formatting helpers for the UI. */

export function fmtAlt(ft: number | null | undefined): string {
  if (ft == null) return '—';
  if (ft === 0) return 'ground';
  return `${Math.round(ft).toLocaleString()} ft`;
}

export function fmtSpeed(kn: number | null | undefined): string {
  if (kn == null) return '—';
  return `${Math.round(kn)} kn`;
}

export function fmtVertRate(fpm: number | null | undefined): string {
  if (fpm == null || fpm === 0) return 'level';
  const v = Math.round(fpm / 100) * 100;
  return `${v > 0 ? '+' : ''}${v} fpm`;
}

export function fmtHeading(deg: number | null | undefined): string {
  if (deg == null) return '—';
  return `${Math.round(deg)}°`;
}

export function fmtSeen(sec: number | null | undefined): string {
  if (sec == null) return '—';
  if (sec < 60) return `${Math.round(sec)}s ago`;
  const m = Math.round(sec / 60);
  return `${m}m ago`;
}

export function fmtDist(nm: number | null | undefined): string {
  if (nm == null) return '—';
  if (nm < 10) return `${nm.toFixed(1)} nm`;
  return `${Math.round(nm)} nm`;
}

export function compassLabel(deg: number): string {
  const dirs = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return dirs[Math.round(((deg % 360) / 45)) % 8];
}

export function cls(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
